import { MatchedGuestProfiles } from '@mews-commander/guest-profile';
import {
    setTotalMatchingGuestProfileHistory,
    updateTotalMatchingGuestProfileHistory,
} from '../store/accountMergeStore';

interface UseNavigateToNextMatchParams {
    totalProfileMatches: number;
    matchedGuestProfiles: MatchedGuestProfiles | null | undefined;
}

export const useNavigateToNextMatch = ({ totalProfileMatches, matchedGuestProfiles }: UseNavigateToNextMatchParams) => {
    return () => {
        if (totalProfileMatches <= 0) {
            return;
        }

        if (!matchedGuestProfiles) {
            setTotalMatchingGuestProfileHistory({ totalProfileMatches: 0 });
            return;
        }

        updateTotalMatchingGuestProfileHistory({
            totalProfileMatches: totalProfileMatches - 1,
            previousMatchId: matchedGuestProfiles.id,
        });
    };
};
